module.exports = __webpack_public_path__ + "static/media/ico_simulation_skin_pores.d91366b8.png";